import { Post } from '@/payload-types'
import { formatAuthors } from '@/utilities/formatAuthors'
import { cn } from '@/utilities/ui'
import { ClassValue } from 'clsx'
import Link from 'next/link'

const authorNameComponent = (authors: NonNullable<NonNullable<Post['populatedAuthors']>[number]>[], postId: string) => {
    const authorNameComponent = (author: PopulatedAuthor) => {
        return (
            <Link href={`/author/${author.username}`} key={`${postId}-${author.id}`} className='text-black no-underline font-bold text-[18px] leading-[21px]'>
                {author.name}
            </Link>
        )
    }

    return authors.map(authorNameComponent)
}

type PopulatedAuthor = NonNullable<NonNullable<Post['populatedAuthors']>[number]>

type Props = {
    authors?: Array<PopulatedAuthor> | null
    postId: string
    styles?: {
        by?: ClassValue
        authors?: ClassValue
    }
}

export function ByAuthor({ authors, postId, styles }: Props) {
    const hasAuthors = authors && authors.length > 0 && formatAuthors(authors) !== ''
    if (!hasAuthors) {
        return null
    }

    // Ensure we don't have any authors without a name
    const filteredAuthors = authors.filter((author) => author.name)

    return filteredAuthors.length > 0 ? (
        <div className='flex font-bold text-[18px] leading-[21px]'>
            {hasAuthors && (
                <>
                    <span className={cn('pr-1', styles?.by)}>By</span>
                    <span className={cn(styles?.authors)}>{authorNameComponent(filteredAuthors, postId)}</span>
                </>
            )}
        </div>
    ) : null
}
